import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  configuringShipmentsText: {
    defaultMessage: 'Configuring shipments...',
    description: 'Loading message shown while shipments are being created',
    id: 'zxd6Wo',
  },
  orderNumberLabel: {
    defaultMessage: 'Order number: {orderNumber}',
    description: 'Label displaying the created order number',
    id: 'JRSTDJ',
  },
  additionalInfoRequiredText: {
    defaultMessage: 'You will also need to provide the following information on the Order Details page:',
    description: 'Text explaining that additional information is required on the order details page',
    id: 'dppcX7',
  },
  packageDimensionsItem: {
    defaultMessage: 'Package dimensions',
    description: 'Bullet point item for package dimensions requirement',
    id: 'Urae6R',
  },
  packageWeightItem: {
    defaultMessage: 'Package weight',
    description: 'Bullet point item for package weight requirement',
    id: 'H+GjRE',
  },
  shippingServiceItem: {
    defaultMessage: 'Shipping service',
    description: 'Bullet point item for shipping service requirement',
    id: '2sDB8E',
  },
  initialModalExplanation: {
    defaultMessage:
      'This will create a single order from your ASN and split it into multiple shipments, one for each box. You will be able to configure and manage all shipments from the orders tab under awaiting shipments.',
    description:
      'Explanation text shown before creating orders from ASN. An ASN (Advanced Shipping Notice) is a label attached to a shipment that is required when sending inventory to a fulfillment warehouse.',
    id: 'DkRvVv',
  },
  storeSelectionLabel: {
    defaultMessage: 'Select Store',
    description: 'Label for the manual store selection dropdown',
    id: '3b18Fp',
  },
  automationWarning: {
    defaultMessage:
      'If you have automation rules that automatically delegate orders to a fulfillment provider (such as Fulfilled by ShipStation), make sure those rules exclude the store you have selected. Otherwise, the inbound shipments you create here could be mistakenly sent to your 3PL for fulfillment instead of being used to send inventory to the warehouse.',
    description: 'Warning message about automation rules that might affect the order that is created',
    id: '45HvKr',
  },
});
